import React, { useEffect, useState } from "react";
import "./ContactUs.css";
import { useAuth } from "../contexts/AuthContext";
import emailjs from "@emailjs/browser";

const ContactUs = () => {
  const { user } = useAuth();
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://cdn.jsdelivr.net/npm/@emailjs/browser@3/dist/email.min.js";
    script.onload = () => {
      emailjs.init(process.env.REACT_APP_EMAIL_JS_USER_ID);
    };
    document.body.appendChild(script);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!user) {
      alert("Please login to contact us");
      return;
    }
    const templateParams = {
      name: e.target.elements["name"].value,
      email: user.email,
      message: e.target.elements["message"].value,
    };

    emailjs
      .send(
        process.env.REACT_APP_EMAIL_JS_SERVICE_ID,
        process.env.REACT_APP_EMAIL_JS_SEND_TEMPLATE_ID,
        templateParams,
      )
      .then(
        (response) => {
          setIsSuccess(true);
          setAlertMessage(
            "Thank you!\nYour message has been sent successfully. \nWe'll get back to you shortly.",
          );
          setShowAlert(true);
          e.target.reset();
        },
        (error) => {
          setIsSuccess(false);
          setAlertMessage(
            "Oops!\nSomething went wrong while sending your message. \nPlease try again later or contact us directly at loadfinder@cinesis.ai.",
          );
          setShowAlert(true);
        },
      );

    emailjs
      .send(
        process.env.REACT_APP_EMAIL_JS_SERVICE_ID,
        process.env.REACT_APP_EMAIL_JS_CONFIRMATION_TEMPLATE_ID,
        templateParams,
      )
      .then(
        (response) => {
          console.log("Sent thank-you!", response.status, response.text);
        },
        (error) => {
          console.error("Failed to send thank-you", error);
        },
      );

    const notification = document.getElementById("messageNotification");
    if (notification) {
      notification.classList.add("show");
      setTimeout(() => {
        notification.classList.remove("show");
      }, 1000);
    }

    e.target.reset();
  };
  return (
    <div className="contact-container">
      <h1>Contact Us</h1>
      <p
        style={{
          textAlign: "center",
          fontWeight: "400",
          fontSize: "1rem",
          lineHeight: "1.6",
          maxWidth: "500px",
          margin: "0 auto 1.5rem",
          color: "var(--text-secondary)",
        }}
      >
        We’d love to hear from you! Share your feedback, report bugs, or ask
        questions, and we’ll get back to you as soon as possible.
      </p>
      <form id="contact-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input name="name" type="text" required />
        </div>

        <div className="form-group">
          <label htmlFor="message">Message:</label>
          <textarea name="message" rows="6" required />
        </div>
        <button
          type="submit"
          style={{
            backgroundColor: "var(--primary)",
            color: "var(--button-text)",
          }}
        >
          SEND MESSAGE
        </button>
      </form>

      {showAlert && (
        <div
          className={`alert ${isSuccess ? "success" : "error"}`}
          onClick={() => setShowAlert(false)}
        >
          {alertMessage.split("\n").map((line, i) => (
            <div key={i} style={{ marginBottom: i === 0 ? "8px" : "0" }}>
              {line}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ContactUs;
